/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ApiUsersVerificationService } from './services/api-users-verification.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ApiUsersVerificationService,
    ApiConfiguration
  ],
})
export class VerificationCodeApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<VerificationCodeApiModule> {
    return {
      ngModule: VerificationCodeApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: VerificationCodeApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('VerificationCodeApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
